import React from "react";
import {useTranslation} from "react-i18next";
import { motion } from "framer-motion";
import CommercialVehicleCard from "../../utility/CommercialVehicleCard";
import { fadeInUp, staggerContainer, staggerItem } from "../../utility/framerMotionAnimations";

const CommercialVehicleBusinessSection = () =>{
    const {t} =useTranslation('commercialVehicleLoanPage');
    return(
        <>
        <section className="section-container">
            <div className="commercial-vehicle-business-section">
                <motion.div 
                    className="commercial-vehicle-business-section-top"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.2, margin: "0px 0px -100px 0px" }}
                    variants={fadeInUp}
                >
                    <motion.div 
                        className="commercial-vehicle-business-section-top-content"
                        variants={fadeInUp}
                    >
                        {t('commercial-vehicle-business-section-heading')}
                    </motion.div>
                </motion.div>
            </div>
        </section>
        <section className="card-section-container">
        <motion.div 
            className="commercial-vehicle-business-section-bottom"
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.2, margin: "0px 0px -100px 0px" }}
        >
                    <motion.div 
                        className="commercial-vehicle-business-section-bottom-sliding-div"
                        variants={staggerItem}
                    >
                    <CommercialVehicleCard 
                        title={t('commercial-vehicle-card1.title')} 
                        content={t('commercial-vehicle-card1.description')}
                        backgroundColor="linear-gradient(138.62deg, #E5DBEF 0.09%, #FFFFFF 69.08%)"
                        image="/images/passenger-vehicle-img.png"
                    />
                    <CommercialVehicleCard 
                       title={t('commercial-vehicle-card2.title')} 
                       content={t('commercial-vehicle-card2.description')} 
                        backgroundColor="linear-gradient(140.06deg, #F4E7D4 1.2%, #FFFFFF 78.92%)"
                        image="/images/light-vehicle-img.png"
                    />
                    <CommercialVehicleCard 
                        title={t('commercial-vehicle-card3.title')} 
                        content={t('commercial-vehicle-card3.description')} 
                        backgroundColor="linear-gradient(138.76deg, #D0D9F0 1.91%, #FFFFFF 79.24%)"
                        image="/images/two-wheeler-img.png"
                    />
                    <CommercialVehicleCard 
                        title={t('commercial-vehicle-card4.title')} 
                        content={t('commercial-vehicle-card4.description')} 
                        backgroundColor="linear-gradient(138.62deg, rgba(252, 196, 157, 0.62) 0.09%, #FFFFFF 69.08%)"
                        image="/images/big-job-img.png"
                    />
                    <CommercialVehicleCard 
                        title={t('commercial-vehicle-card5.title')} 
                        content={t('commercial-vehicle-card5.description')}
                        backgroundColor="linear-gradient(139.04deg, #CDE3ED 2.39%, #FFFFFF 67%)"
                        image="/images/heavy-vehicle-img.png"
                    />
                    <CommercialVehicleCard 
                        title={t('commercial-vehicle-card6.title')} 
                        content={t('commercial-vehicle-card6.description')} 
                        backgroundColor="linear-gradient(138.62deg, #F2CFD7 0.09%, #FFFFFF 76.08%)"
                        image="/images/quick-approval-img.png"
                    />
                    </motion.div>
                    {/*Add `aria-hidden` to hide the duplicated cards from screen readers.*/}
                    <motion.div 
                        className="ariaihidden commercial-vehicle-business-section-bottom-sliding-div"
                        variants={staggerItem}
                    >
                    <CommercialVehicleCard 
                        title={t('commercial-vehicle-card1.title')} 
                        content={t('commercial-vehicle-card1.description')}
                        backgroundColor="linear-gradient(138.62deg, #E5DBEF 0.09%, #FFFFFF 69.08%)"
                        image="/images/passenger-vehicle-img.png"
                    />
                    <CommercialVehicleCard 
                       title={t('commercial-vehicle-card2.title')} 
                       content={t('commercial-vehicle-card2.description')} 
                        backgroundColor="linear-gradient(140.06deg, #F4E7D4 1.2%, #FFFFFF 78.92%)"
                        image="/images/light-vehicle-img.png"
                    />
                    <CommercialVehicleCard 
                        title={t('commercial-vehicle-card3.title')} 
                        content={t('commercial-vehicle-card3.description')} 
                        backgroundColor="linear-gradient(138.76deg, #D0D9F0 1.91%, #FFFFFF 79.24%)"
                        image="/images/two-wheeler-img.png"
                    />
                    <CommercialVehicleCard 
                        title={t('commercial-vehicle-card4.title')} 
                        content={t('commercial-vehicle-card4.description')} 
                        backgroundColor="linear-gradient(138.62deg, rgba(252, 196, 157, 0.62) 0.09%, #FFFFFF 69.08%)"
                        image="/images/big-job-img.png"
                    />
                    <CommercialVehicleCard 
                        title={t('commercial-vehicle-card5.title')} 
                        content={t('commercial-vehicle-card5.description')}
                        backgroundColor="linear-gradient(139.04deg, #CDE3ED 2.39%, #FFFFFF 67%)"
                        image="/images/heavy-vehicle-img.png"
                    />
                    <CommercialVehicleCard 
                        title={t('commercial-vehicle-card6.title')} 
                        content={t('commercial-vehicle-card6.description')} 
                        backgroundColor="linear-gradient(138.62deg, #F2CFD7 0.09%, #FFFFFF 76.08%)"
                        image="/images/quick-approval-img.png"
                    />
                    </motion.div>
                </motion.div>
            
        </section>

        </>
                
                
      
    )
}

export default CommercialVehicleBusinessSection;